import { NumericValidators } from './numeric-validators';

export const validators: any[] = [ NumericValidators];

export * from './numeric-validators';

